import * as React from 'react';
import cx from 'classnames';
import {Logo} from 'components/Logo';
import {Nav} from 'components/Nav';
import {MobileMenu} from 'components/MobileMenu';
import style from './Header.css';

export class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isStickyUp: false,
            isStickyDown: false,
            isShow: false,
            isHide: false
        };
        this.pageYOffset = 0;
        this.lastIsSticky = false;
    }

    componentDidMount() {
        this.offsetTop = this.header.offsetTop;
        this.clientHeight = this.header.clientHeight;
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll = () => {
        const yOffset = window.pageYOffset;
        const isScrollUp = this.pageYOffset > yOffset;
        this.pageYOffset = yOffset;

        const clientHeight = this.clientHeight;
        const offsetTop = this.offsetTop;

        let sticky = isScrollUp && this.lastIsSticky ? offsetTop : offsetTop + clientHeight;

        const isSticky = yOffset > sticky;
        const isShow = this.lastIsSticky && isSticky && isScrollUp;
        const isHide = this.lastIsSticky && isSticky && !isScrollUp;

        const newState = {
            isSticky,
            isShow,
            isHide
        };

        this.lastIsSticky = isSticky;
        if (
            this.state.isSticky !== isSticky ||
            this.state.isShow !== isShow ||
            this.state.isHide !== isHide
        ) {
            this.setState(newState);
        }
    };

    render() {
        const {className} = this.props;
        const classes = cx(style.root, className, {
            [style.sticky]: this.state.isSticky,
            [style.show]: this.state.isShow,
            [style.hide]: this.state.isHide
        });

        return (
            <header ref={c => this.header = c} className={classes}>
                <div className="container">
                    <Logo className={style.logo}/>
                    <Nav className={style.nav}/>
                    <MobileMenu
                        className={style.mobileMenu}
                        onOpen={this.props.onOpenMenu}
                    />
                </div>
            </header>
        );
    }
}